import React, { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';

const ProtectedRoute = ({ module, action, children, fallback = '/' }) => {
    const { user } = useAuth();

    const checkAccess = (moduleName, actionName) => {
        if (!user?.role?.permissions) return false;
        const modulePermissions = user.role.permissions[moduleName];
        if (!modulePermissions) return false;
	// When a specific action is provided, check that action directly
        // if (actionName) return modulePermissions[actionName] === true;
        // Otherwise check if any permission is enabled (calculated visibility)
        // return ['view', 'add', 'change', 'delete'].some(a => modulePermissions[a] === true);
        return modulePermissions.ui_visible !== false;
    };

    const canAccess = checkAccess(module, action);

    useEffect(() => {
        if (!canAccess && user) {
            toast.error(`Access denied: You don't have permission to view ${module.replace('_', ' ')}`);
        }
    }, [canAccess, module, user?.email]); // eslint-disable-line react-hooks/exhaustive-deps

    // If module is not ui_visible, redirect to fallback
    if (!canAccess) {
        return <Navigate to={fallback} replace />;
    }

    // If module is ui_visible, render the children
    return children;
};

export default ProtectedRoute; 
